<div class="logo-container">
  <a href="/">
    <div class="logo"></div>
    <div class="symbiot"></div>
  </a>
</div>
